import { Separator } from '@nesso/ui/primitives/separator';

import {
    FORMAT_OPTIONS,
    IDENTIFIER_OPTIONS,
    LENGTH_OPTIONS,
    NoteToggleInput,
    TreatmentApproachesInput,
} from '@/features/practice/edit-notes-settings';

export function SessionNoteSettingsForNotes() {
    return (
        // A div, not a fragment, so the page's space-y-8 doesn't space every row.
        <div>
            {/* Figma's zero-height divider draws one pixel above the content top. */}
            <Separator className="-mt-px mb-4" />
            <TreatmentApproachesInput />
            <NoteToggleInput field="noteFormat" label="Format" options={FORMAT_OPTIONS} />
            <NoteToggleInput field="noteLength" label="Length" options={LENGTH_OPTIONS} />
            <NoteToggleInput field="identifier" label="Identifier" options={IDENTIFIER_OPTIONS} />
        </div>
    );
}
